<myp-list-item
  [photo]="ms.snapshot ? ms.snapshot.product.imageUrl : ms.bodyImageUrl ? ms.bodyImageUrl : './assets/images/default_avatar.jpg'"
  [showImage]="ms.snapshot?.product?.imageUrl || ms.bodyImageUrl"
  [title]="ms.snapshot ? ms.snapshot.product.title : ms.productName"
  [imageRound]="false"
  [collapsible]="collapsible"
  [includeChevron]="false"
  [showBackground]="true"
  [metadata]="[
    { title: ('sphere.date_added' | translate), value: ms.created ? (ms.created | date) : ('general.unknown' | translate) },
    { title: ('general.serial_number' | translate), value: ms.serial?.split('#')[1] || ms.serial },
    { title: ('general.sku' | translate), value: ms.sku || ('general.no_sku_entered' | translate) },
    showUserId ? { title: ('general.user_id' | translate), value: ms.userId } : { title: ('orders.status' | translate), value: ms.migrated ? ('general.converted' | translate) : 'Pending' },
  ]"
  [marginBottom]="'10px'"
>
  @if (collapsible) {
    <div class="collapsible-content">
      <div class="row">
        <div class="col-md-12 col-lg-8">
          <h2 class="section-header">{{ "sphere.details" | translate }}</h2>
          <div class="row">
            <div class="col-12 col-md-6 m-b-20">
              <div class="text-muted t-12">Product Name</div>
              <div class="font-weight-bold">
                {{ ms.snapshot?.product?.title || ms.productName || ("com.no_name_entered" | translate) }}
              </div>
            </div>
            <div class="col-12 col-md-6 m-b-20">
              <div class="text-muted t-12">{{ "general.serial_number" | translate }}</div>
              <div class="font-weight-bold">
                @if (!ms.showingEditSerial) {
                  {{ ms.serial }}
                  <button class="small-btn m-l-10" (click)="ms.showingEditSerial = true; ms.editingSerial = ms.serial">{{ "general.edit" | translate }}</button>
                }
                @if (ms.showingEditSerial) {
                  <input type="text" class="form-control" [(ngModel)]="ms.editingSerial" (keyup.enter)="updateSerial(ms)" />
                  <button class="btn btn-primary btn-sm m-t-10" type="button" (click)="updateSerial(ms)" [disabled]="savingSerial">
                    @if (savingSerial) {
                      <fa-icon icon="spinner" animation="spin"></fa-icon>
                    }
                    {{ savingSerial ? ("general.saving_dots" | translate) : ("general.save" | translate) }}
                  </button>
                  <button class="btn btn-blank btn-sm m-t-10" type="button" (click)="ms.showingEditSerial = false; ms.editingSerial = undefined">{{ "sphere.cancel" | translate }}</button>
                }
              </div>
            </div>
            <div class="col-12 col-md-6 m-b-20">
              <div class="text-muted t-12">{{ "general.sku" | translate }}</div>
              <div class="font-weight-bold">
                @if (!ms.showingEnterSku) {
                  {{ ms.sku || ("general.no_sku_entered" | translate) }}
                  @if (!ms.sku) {
                    <button class="small-btn m-l-10" (click)="ms.showingEnterSku = true">{{ "general.enter_sku" | translate }}</button>
                  }
                }
                @if (ms.showingEnterSku) {
                  <input type="text" class="form-control" [(ngModel)]="ms.sku" (keyup.enter)="onSaveSku.emit(ms)" />
                  <button class="btn btn-primary btn-sm m-t-10" type="button" (click)="onSaveSku.emit(ms)" [disabled]="savingSku">
                    @if (savingSku) {
                      <fa-icon icon="spinner" animation="spin"></fa-icon>
                    }
                    {{ savingSku ? ("general.saving_dots" | translate) : ("general.save" | translate) }}
                  </button>
                  <button class="btn btn-blank btn-sm m-t-10" type="button" (click)="ms.sku = undefined; ms.showingEnterSku = false">{{ "sphere.cancel" | translate }}</button>
                }
              </div>
            </div>
            @if (showUserId) {
              <div class="col-12 col-md-6 m-b-20">
                <div class="text-muted t-12">{{ "general.user_id" | translate }}</div>
                <div class="font-weight-bold">
                  <a [routerLink]="['/customer/detail/', ms.userId]">{{ ms.userId }}</a>
                </div>
              </div>
            }
            @if (ms.shopLink) {
              <div class="col-12 col-md-6 m-b-20">
                <div class="text-muted t-12">{{ "general.shop_link" | translate }}</div>
                <div class="font-weight-bold">
                  <a [href]="ms.shopLink" target="_blank">{{ ms.shopLink }}</a>
                </div>
              </div>
            }
          </div>
          @if (ms.bodyImageUrl || ms.serialImageUrl) {
            <div class="row">
              @if (ms.bodyImageUrl) {
                <div class="col-lg-3 col-md-4 col-12 m-b-20">
                  <div class="text-muted t-12">{{ "general.gear_body" | translate }}</div>
                  @if (ms.bodyImageFailed) {
                    <div class="img-thumbnail w-full unviewable-photo">
                      <fa-icon icon="file-image" class="t-20 m-b-5"></fa-icon>
                      <div class="t-12 text-muted break-word">{{ ms.bodyImageFileName }}</div>
                      <div class="t-12 text-muted m-b-5">This browser can't display this image format.</div>
                      <a [href]="ms.bodyImageUrl" target="_blank" rel="noopener">Download</a>
                    </div>
                  } @else {
                    <img [src]="ms.bodyImageUrl" (click)="onShowImage.emit(ms.bodyImageUrl)" (error)="markPhotoFailed(ms, 'body')" class="img-thumbnail w-full" />
                  }
                </div>
              }
              @if (ms.serialImageUrl) {
                <div class="col-lg-3 col-md-4 col-12 m-b-20">
                  <div class="text-muted t-12">{{ "general.serial_number_photo" | translate }}</div>
                  @if (ms.serialImageFailed) {
                    <div class="img-thumbnail w-full unviewable-photo">
                      <fa-icon icon="file-image" class="t-20 m-b-5"></fa-icon>
                      <div class="t-12 text-muted break-word">{{ ms.serialImageFileName }}</div>
                      <div class="t-12 text-muted m-b-5">This browser can't display this image format.</div>
                      <a [href]="ms.serialImageUrl" target="_blank" rel="noopener">Download</a>
                    </div>
                  } @else {
                    <img [src]="ms.serialImageUrl" (click)="onShowImage.emit(ms.serialImageUrl)" (error)="markPhotoFailed(ms, 'serial')" class="img-thumbnail w-full" />
                  }
                </div>
              }
            </div>
          }
        </div>
        <div class="col-12 col-lg-4">
          <h2 class="section-header">{{ "general.actions" | translate }}</h2>
          <div class="m-b-5">
            <button type="button" class="small-btn" (click)="onConvert.emit(ms)" [disabled]="converting">
              @if (converting) {
                <fa-icon icon="spinner" animation="spin"></fa-icon>
                {{ "general.converting_dots" | translate }}
              } @else {
                <fa-icon icon="arrow-alt-circle-up" class="m-r-5" style="color: green !important"></fa-icon>
                {{ "general.convert_to_real_registration" | translate }}
              }
            </button>
          </div>
          <hr class="m-y-20" />
          <div class="m-b-5">
            <button type="button" class="small-btn red" (click)="onDelete.emit(ms)">
              <fa-icon icon="trash" class="m-r-5" style="color: red !important"></fa-icon>
              {{ "general.delete_missing_serial" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</myp-list-item>
